import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../../useAppTheme";

type Props = {
	instruction: string;
};

export const ItemInstruction = ({ instruction }: Props) => {
	const theme = useAppTheme();

	return (
		<Text
			variant="bodyLarge"
			style={{
				color: theme.palette.text.primary,
				fontStyle: "italic",
				fontWeight: "600",
			}}
		>
			{instruction}
		</Text>
	);
};
